/* Calendar estimates use Morocco's local date, independently of the visitor timezone. */
(() => {
  const refresh = () => {
    const parts = new Intl.DateTimeFormat('en-CA', {timeZone:'Africa/Casablanca', year:'numeric', month:'2-digit', day:'2-digit'}).formatToParts(new Date());
    const value = type => Number(parts.find(part => part.type === type).value);
    const date = new Date(Date.UTC(value('year'), value('month') - 1, value('day')));
    const format = new Intl.DateTimeFormat('fr-FR', {timeZone:'UTC',day:'numeric',month:'long',year:'numeric'});
    date.setUTCDate(date.getUTCDate()+1);
    const start = new Date(date);
    date.setUTCDate(date.getUTCDate()+1);
    const text = format.formatRange ? format.formatRange(start, date) : `${format.format(start)} – ${format.format(date)}`;
    document.querySelectorAll('[data-qeydo-intervention]').forEach(el => {el.textContent=text;});
  };
  refresh();
  document.addEventListener('shopify:section:load', refresh);
  document.addEventListener('visibilitychange', () => {if (!document.hidden) refresh();});
})();
